// table表格样式判断
function tableRowClassName({ row, rowIndex }) {
  if (rowIndex % 2 === 1) {
    return 'warning-row'
  }
  return ''
}

export {
  tableRowClassName
}
